import { Select } from "@admin/components/atoms/Input/Select";
import { Loading } from "@admin/components/atoms/Loading";
import { CompanyLocation, useCommonStore } from "@enos-monorepo/lib";

import { LocationInfo } from "./LocationInfo";

interface LocationProps {
  selectedLocation?: CompanyLocation;
  locations: CompanyLocation[];
  isLoading?: boolean;
}

export function Location({
  selectedLocation,
  locations,
  isLoading,
}: LocationProps) {
  const { setShiftLocation } = useCommonStore();
  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex flex-row align-middle rounded-xl bg-white border-[#DBDFE9] justify-between p-7.5">
      <LocationInfo selectedLocation={selectedLocation} />
      <div className="w-1/6 flex flex-row items-center gap-5">
        <Select
          defaultValue={selectedLocation?.id}
          options={locations.map((l) => {
            return { label: l.name, value: l.id };
          })}
          onChange={(e) => {
            setShiftLocation(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
